import { render, staticRenderFns } from "./cancelMdfeTips.vue?vue&type=template&id=11799b9a&scoped=true"
import script from "./cancelMdfeTips.vue?vue&type=script&lang=js"
export * from "./cancelMdfeTips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11799b9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11799b9a')) {
      api.createRecord('11799b9a', component.options)
    } else {
      api.reload('11799b9a', component.options)
    }
    module.hot.accept("./cancelMdfeTips.vue?vue&type=template&id=11799b9a&scoped=true", function () {
      api.rerender('11799b9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/mdfe/cmp/cancelMdfeTips.vue"
export default component.exports